var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo1157({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 94.687,
    viewBox: "0 0 92 94.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.h{fill:#fff;}.b{fill:#19141e;}.b,.c,.d,.e,.f,.g,.h,.j{fill-rule:evenodd;}.c{fill:#f2bfe4;}.d{opacity:0.399;}.e{fill:#405fd3;}.f{fill:#0d0b6d;}.g{fill:#2437a8;}.i,.j,.k{fill:none;stroke:#252535;}.i,.j{stroke-width:2px;}.k{stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.687)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 46,
    cy: 45.5,
    rx: 46,
    ry: 45.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.291)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.56,76.979c0,7.655-4.922,13.861-10.994,13.861s-10.993-6.205-10.993-13.861,4.922-13.861,10.993-13.861,10.994,6.206,10.994,13.861",
    transform: "translate(-74.616 -53.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.928,137.486l-.46-15.92s19.3,1.541,23.431-.609c0,0,5.047-26.06-.972-40.491l-.122-.562L57.072,75.129,54.789,98.556c-1.372-4.056-12.7-8.655-15.656-2.847-6.415,12.586,16.522,21.061,16.522,21.061l-2.329,20.908",
    transform: "translate(-38 -59.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M96.808,159.651l-13.016-2.8,12.954,8.77Z",
    transform: "translate(-59.34 -97.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M126.873,118.443l4.5,11.02-5.39.069Z",
    transform: "translate(-79 -79.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M113.952,117.278a2.725,2.725,0,1,1-3.166-2.2,2.73,2.73,0,0,1,3.166,2.2",
    transform: "translate(-70.875 -77.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M142.256,117.278a2.725,2.725,0,1,1-3.166-2.2,2.73,2.73,0,0,1,3.166,2.2",
    transform: "translate(-84.065 -77.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M68.54,70c.15-3.244.6-4.364,18.161.1,24.548,6.239,33.553-18.32,23.872-23.93-2.683-1.554-5.474-.649-8.693.393-3.579,1.159-7.685,2.49-12.755.8-14.321-4.771-24.1-1.256-29.779,1.28-5.605,2.506-12.545,11.234-11.108,20.8a56.088,56.088,0,0,0,2.3,9.833A19.034,19.034,0,0,1,62.5,88.513C66.421,86.656,68.053,80.487,68.54,70Z",
    transform: "translate(-42.682 -45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M113.629,139.977a6.363,6.363,0,0,0,5.471,3.077Z",
    transform: "translate(-73.244 -89.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M113.629,139.977a6.363,6.363,0,0,0,5.471,3.077",
    transform: "translate(-73.244 -89.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M114.326,114.032a6.234,6.234,0,1,1-6.234-6.247A6.24,6.24,0,0,1,114.326,114.032Z",
    transform: "translate(-67.759 -74.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M143.72,114.032a6.234,6.234,0,1,1-6.233-6.247A6.24,6.24,0,0,1,143.72,114.032Z",
    transform: "translate(-81.457 -74.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M127.949,120.026h-2.7",
    transform: "translate(-78.662 -79.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M88.419,119.484h-15.4",
    transform: "translate(-54.32 -79.71)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo1157);
export default __webpack_public_path__ + "static/media/Grupo 1157.abbdde87fb0b2591430549c0eae87241.svg";
export { ForwardRef as ReactComponent };